"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accessiblePrefixes = void 0;
exports.countBarrierFreeAndStdAccessible = countBarrierFreeAndStdAccessible;
exports.default = AccessibleRoomTypeOptionsComponent;
exports.getAccessibleRoomCounts = getAccessibleRoomCounts;
exports.getAvailableAccessibleroomsPerRoom = getAvailableAccessibleroomsPerRoom;
exports.handleRenderWithReSelections = handleRenderWithReSelections;
exports.initialRenderWithPreSelections = initialRenderWithPreSelections;
exports.isSelectionRequired = isSelectionRequired;
exports.reSelectionRoomTypesRequired = reSelectionRoomTypesRequired;
exports.renderGuestNumbers = renderGuestNumbers;
exports.updateRoomsSelections = updateRoomsSelections;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _api = require("@whitbread-eos/api");
var _atoms = require("@whitbread-eos/atoms");
var _utils = require("@whitbread-eos/utils");
var _nextI18next = require("next-i18next");
var _react2 = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var accessiblePrefixes = exports.accessiblePrefixes = ['Accessible', 'Barrierefreies', 'Rollstuhlgerechtes'];
function isSelectionRequired(room, accessiblePrefixes) {
  var _room$roomTypes;
  return room === null || room === void 0 || (_room$roomTypes = room.roomTypes) === null || _room$roomTypes === void 0 ? void 0 : _room$roomTypes.some(roomType => accessiblePrefixes === null || accessiblePrefixes === void 0 ? void 0 : accessiblePrefixes.some(prefix => roomType === null || roomType === void 0 ? void 0 : roomType.startsWith(prefix)));
}
function getAccessibleRoomCounts(hotelInventoryResponse) {
  var _hotelInventoryRespon, _hotelInventoryRespon2;
  var roomTypeInventories = (_hotelInventoryRespon = hotelInventoryResponse === null || hotelInventoryResponse === void 0 || (_hotelInventoryRespon2 = hotelInventoryResponse.dataHotelInventory) === null || _hotelInventoryRespon2 === void 0 || (_hotelInventoryRespon2 = _hotelInventoryRespon2.hotelInventory) === null || _hotelInventoryRespon2 === void 0 ? void 0 : _hotelInventoryRespon2.roomTypeInventories) !== null && _hotelInventoryRespon !== void 0 ? _hotelInventoryRespon : [];
  var bfrCountInventoryTotal = 0;
  var strCountInventoryTotal = 0;
  roomTypeInventories.forEach(room => {
    switch (room.code) {
      case _api.ROOM_TYPE.BRFDBL:
      case _api.ROOM_TYPE.BRFZPL:
      case _api.ROOM_TYPE.BRFTWN:
        bfrCountInventoryTotal += room.availableCount;
        break;
      case _api.ROOM_TYPE.WET_DOUBLE:
      case _api.ROOM_TYPE.LOWERED_DOUBLE:
        strCountInventoryTotal += room.availableCount;
        break;
      default:
        break;
    }
  });
  return {
    bfrCountInventoryTotal,
    strCountInventoryTotal
  };
}
function countBarrierFreeAndStdAccessible(bedRoomTypesData, initialRoomTypeCounts) {
  return bedRoomTypesData === null || bedRoomTypesData === void 0 ? void 0 : bedRoomTypesData.reduce((counts, item) => {
    switch (item) {
      case _api.ROOM_TYPE.BARRIER_FREE:
        counts.barrierFreeCount++;
        break;
      case _api.ROOM_TYPE.STANDARD_ACCESSIBLE:
        counts.standardAccesssibleCount++;
        break;
      default:
        break;
    }
    return counts;
  }, _objectSpread({}, initialRoomTypeCounts));
}
function updateRoomsSelections(updatedSelections, updatedRooms) {
  updatedSelections.forEach((selection, roomIndex) => {
    var room = updatedRooms[roomIndex];
    if (!room.accessibleRoomTypes) {
      room.accessibleRoomTypes = [];
    }
    if (selection === _api.ROOM_TYPE.STANDARD_ACCESSIBLE && !room.accessibleRoomTypes.includes(_api.ROOM_TYPE.STANDARD_ACCESSIBLE)) {
      room.accessibleRoomTypes = [...room.accessibleRoomTypes, _api.ROOM_TYPE.STANDARD_ACCESSIBLE];
    } else if (selection === _api.ROOM_TYPE.BARRIER_FREE && !room.accessibleRoomTypes.includes(_api.ROOM_TYPE.BARRIER_FREE)) {
      room.accessibleRoomTypes = [...room.accessibleRoomTypes, _api.ROOM_TYPE.BARRIER_FREE];
    }
  });
}
function handleRenderWithReSelections(handleRenderWithReSelectionsProps) {
  var {
    rooms,
    accessibleRoomSelections,
    onAccessibleRoomSelection,
    onRoomTypeSelection,
    hotelInventoryResponse,
    currentRoomIndex,
    setAvailableAccessibleRoomsPerRoom,
    initialRoomTypeCounts
  } = handleRenderWithReSelectionsProps;
  var {
    bfrCountInventoryTotal,
    strCountInventoryTotal
  } = getAccessibleRoomCounts(hotelInventoryResponse);
  var {
    standardAccesssibleCount: scrCount,
    barrierFreeCount: bfrCount
  } = countBarrierFreeAndStdAccessible(accessibleRoomSelections, initialRoomTypeCounts);
  var updatedRooms = [...rooms];
  var updatedSelections = [...accessibleRoomSelections];
  var onRenderSelection = updatedSelections[currentRoomIndex];
  var updatedIds = [];
  if (onRenderSelection === _api.ROOM_TYPE.STANDARD_ACCESSIBLE && scrCount >= strCountInventoryTotal) {
    updatedRooms.forEach((room, roomIndex) => {
      if (roomIndex === currentRoomIndex) return;
      if (!room.accessibleRoomTypes) {
        room.accessibleRoomTypes = [];
      }
      if (scrCount > strCountInventoryTotal && updatedSelections[roomIndex] === _api.ROOM_TYPE.STANDARD_ACCESSIBLE) {
        updatedSelections[roomIndex] = _api.ROOM_TYPE.BARRIER_FREE;
        room.accessibleRoomTypes = [...room.accessibleRoomTypes, _api.ROOM_TYPE.BARRIER_FREE];
        updatedIds.push(roomIndex);
        onAccessibleRoomSelection(roomIndex, _api.ROOM_TYPE.BARRIER_FREE);
        onRoomTypeSelection(roomIndex, room.roomTypes[0]);
        scrCount--;
      }
    });
  } else if (onRenderSelection === _api.ROOM_TYPE.BARRIER_FREE && bfrCount >= bfrCountInventoryTotal) {
    updatedRooms.forEach((room, roomIndex) => {
      if (roomIndex === currentRoomIndex) return;
      if (!room.accessibleRoomTypes) {
        room.accessibleRoomTypes = [];
      }
      if (bfrCount > bfrCountInventoryTotal && updatedSelections[roomIndex] === _api.ROOM_TYPE.BARRIER_FREE) {
        updatedSelections[roomIndex] = _api.ROOM_TYPE.STANDARD_ACCESSIBLE;
        room.accessibleRoomTypes = [...room.accessibleRoomTypes, _api.ROOM_TYPE.STANDARD_ACCESSIBLE];
        updatedIds.push(roomIndex);
        onAccessibleRoomSelection(roomIndex, _api.ROOM_TYPE.STANDARD_ACCESSIBLE);
        onRoomTypeSelection(roomIndex, room.roomTypes[0]);
        bfrCount--;
      }
    });
  }
  updateRoomsSelections(updatedSelections, updatedRooms);
  setAvailableAccessibleRoomsPerRoom(getAvailableAccessibleroomsPerRoom(updatedRooms));
}
function getAvailableAccessibleroomsPerRoom(rooms) {
  return rooms === null || rooms === void 0 ? void 0 : rooms.map(room => {
    if (!isSelectionRequired(room, accessiblePrefixes)) {
      return {
        hasAccessibleRoom: false,
        hasBarrierFreeRoom: false
      };
    }
    var accessibleRoomTypes = (room === null || room === void 0 ? void 0 : room.accessibleRoomTypes) || [];
    var hasAccessibleRoom = accessibleRoomTypes === null || accessibleRoomTypes === void 0 ? void 0 : accessibleRoomTypes.includes(_api.ROOM_TYPE.STANDARD_ACCESSIBLE);
    var hasBarrierFreeRoom = accessibleRoomTypes === null || accessibleRoomTypes === void 0 ? void 0 : accessibleRoomTypes.includes(_api.ROOM_TYPE.BARRIER_FREE);
    return {
      hasAccessibleRoom,
      hasBarrierFreeRoom
    };
  });
}
function reSelectionRoomTypesRequired(currentRoomIndex) {
  return currentRoomIndex !== -1;
}
function initialRenderWithPreSelections(rooms, accessibleRoomSelections, availableAccessibleRoomsPerRoom, onAccessibleRoomSelection, onRoomTypeSelection) {
  rooms === null || rooms === void 0 || rooms.forEach((room, roomIndex) => {
    var selectionRequired = isSelectionRequired(room, accessiblePrefixes);
    if (!selectionRequired) return;
    var roomSelected = (accessibleRoomSelections === null || accessibleRoomSelections === void 0 ? void 0 : accessibleRoomSelections[roomIndex]) === _api.ROOM_TYPE.STANDARD_ACCESSIBLE || (accessibleRoomSelections === null || accessibleRoomSelections === void 0 ? void 0 : accessibleRoomSelections[roomIndex]) === _api.ROOM_TYPE.BARRIER_FREE;
    var {
      hasBarrierFreeRoom,
      hasAccessibleRoom
    } = (availableAccessibleRoomsPerRoom === null || availableAccessibleRoomsPerRoom === void 0 ? void 0 : availableAccessibleRoomsPerRoom[roomIndex]) || {};
    if (!roomSelected) {
      var defaultSelection = null;
      if (hasAccessibleRoom) {
        defaultSelection = _api.ROOM_TYPE.STANDARD_ACCESSIBLE;
      } else if (hasBarrierFreeRoom) {
        defaultSelection = _api.ROOM_TYPE.BARRIER_FREE;
      }
      if (defaultSelection) {
        onAccessibleRoomSelection(roomIndex, defaultSelection);
      }
    }
    onRoomTypeSelection(roomIndex, room.roomTypes[0]);
  });
}
function renderGuestNumbers(room, t) {
  var adultsLabel = "".concat(room === null || room === void 0 ? void 0 : room.adults, " ").concat(t("dashboard.bookings.adult".concat((room === null || room === void 0 ? void 0 : room.adults) > 1 ? 's' : '')));
  var childrenLabel = (room === null || room === void 0 ? void 0 : room.children) > 0 ? ", ".concat(room === null || room === void 0 ? void 0 : room.children, " ").concat(t("dashboard.bookings.child".concat((room === null || room === void 0 ? void 0 : room.children) > 1 ? 'ren' : ''))) : '';
  return (0, _jsxRuntime.jsxs)(_react.Text, {
    mt: "1",
    lineHeight: "3",
    "data-testid": "accessible-room-guests",
    children: [adultsLabel, childrenLabel]
  });
}
function AccessibleRoomTypeOptionsComponent(_ref) {
  var {
    rooms,
    onRoomTypeSelection,
    onAccessibleRoomSelection,
    accessibleRoomSelections,
    hotelInventoryResponse
  } = _ref;
  var [hasRun, setHasRun] = (0, _react2.useState)(false);
  var [currentRoomIndex, setCurrentIndex] = (0, _react2.useState)(-1);
  var [forceRender, setForceRender] = (0, _react2.useState)(0);
  var [availableAccessibleRoomsPerRoom, setAvailableAccessibleRoomsPerRoom] = (0, _react2.useState)(getAvailableAccessibleroomsPerRoom(rooms));
  var initialRoomTypeCounts = {
    barrierFreeCount: 0,
    standardAccesssibleCount: 0
  };
  var {
    t
  } = (0, _nextI18next.useTranslation)(['common']);
  var roomTypeCountsTotalsRef = (0, _react2.useRef)(initialRoomTypeCounts);
  (0, _react2.useEffect)(() => {
    if (hasRun || !(accessibleRoomSelections !== null && accessibleRoomSelections !== void 0 && accessibleRoomSelections.length)) return;
    var {
      standardAccesssibleCount,
      barrierFreeCount
    } = countBarrierFreeAndStdAccessible(accessibleRoomSelections, initialRoomTypeCounts);
    roomTypeCountsTotalsRef.current = {
      standardAccesssibleCount,
      barrierFreeCount
    };
    setHasRun(true);
  }, [accessibleRoomSelections, hasRun]);
  (0, _react2.useEffect)(() => {
    var isReOrderingRoomTypesRequired = reSelectionRoomTypesRequired(currentRoomIndex);
    if (forceRender && isReOrderingRoomTypesRequired) {
      handleRenderWithReSelections({
        rooms,
        accessibleRoomSelections: accessibleRoomSelections,
        availableAccessibleRoomsPerRoom,
        onAccessibleRoomSelection,
        onRoomTypeSelection,
        hotelInventoryResponse,
        currentRoomIndex,
        setAvailableAccessibleRoomsPerRoom,
        initialRoomTypeCounts
      });
    }
    initialRenderWithPreSelections(rooms, accessibleRoomSelections, availableAccessibleRoomsPerRoom, onAccessibleRoomSelection, onRoomTypeSelection);
  }, [forceRender, setAvailableAccessibleRoomsPerRoom]);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_react.Heading, _objectSpread(_objectSpread({
      as: "h1",
      "data-testid": "choose-roomtype-title"
    }, headingStyle), {}, {
      children: t('accessible.chooseRoomTypeTitle')
    })), rooms === null || rooms === void 0 ? void 0 : rooms.map((room, roomIndex) => {
      var selectionRequired = isSelectionRequired(room, accessiblePrefixes);
      return (0, _jsxRuntime.jsxs)(_react.Box, {
        mt: {
          base: 'xl',
          xs: '3xl'
        },
        children: [(0, _jsxRuntime.jsx)(_react.Flex, _objectSpread(_objectSpread({}, roomAndGuestsFlexStyle), {}, {
          children: (0, _jsxRuntime.jsxs)(_react.Flex, {
            direction: "column",
            mr: "md",
            children: [(0, _jsxRuntime.jsx)(_react.Heading, _objectSpread(_objectSpread({
              as: "h3",
              "data-testid": "accessible-room-number"
            }, roomHeadingStyle), {}, {
              children: t('booking.hotel.summary.room').replace('[roomNumber]', selectionRequired ? (roomIndex + 1).toString() : "".concat(roomIndex + 1, " ").concat(room.roomTypes[0]))
            })), renderGuestNumbers(room, t)]
          })
        })), selectionRequired ? renderSelectionOptions(roomIndex) : (0, _jsxRuntime.jsx)(_react.Text, {
          mt: {
            base: '1',
            xs: '0'
          },
          "data-testid": "accessible-no-room-type-selection-required",
          children: (0, _utils.renderSanitizedHtml)(t('accessible.no.roomtypeSelection.required'))
        })]
      }, roomIndex);
    })]
  });
  function renderSelectionOptions(roomIndex) {
    var {
      hasBarrierFreeRoom,
      hasAccessibleRoom
    } = (availableAccessibleRoomsPerRoom === null || availableAccessibleRoomsPerRoom === void 0 ? void 0 : availableAccessibleRoomsPerRoom[roomIndex]) || {};
    return (0, _jsxRuntime.jsxs)(_react.Box, {
      maxW: "3xl",
      mt: "lg",
      "data-testid": "accessible-roomtype-dropdown",
      children: [(0, _jsxRuntime.jsx)(_atoms.RadioButton, {
        type: "standard-accessible-room",
        value: "standard-accessible-room",
        onChange: () => {
          setForceRender(prev => prev + 1);
          setCurrentIndex(roomIndex);
          onAccessibleRoomSelection(roomIndex, _api.ROOM_TYPE.STANDARD_ACCESSIBLE);
        },
        isChecked: accessibleRoomSelections[roomIndex] === _api.ROOM_TYPE.STANDARD_ACCESSIBLE,
        isDisabled: !hasAccessibleRoom,
        children: (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [(0, _jsxRuntime.jsx)(_react.Text, {
            fontWeight: "bold",
            "data-testid": "accessible-standard-room",
            children: t('accessible.standardRoom')
          }), (0, _jsxRuntime.jsx)(_react.Box, {
            className: "formatLinks",
            children: (0, _utils.renderSanitizedHtml)(t('accessible.standardRoom.text'))
          })]
        })
      }), (0, _jsxRuntime.jsx)(_react.Box, {
        mt: "1em"
      }), (0, _jsxRuntime.jsx)(_atoms.RadioButton, {
        type: "barrier-free-room",
        value: "barrier-free-room",
        onChange: () => {
          setForceRender(prev => prev + 1);
          setCurrentIndex(roomIndex);
          onAccessibleRoomSelection(roomIndex, _api.ROOM_TYPE.BARRIER_FREE);
        },
        isChecked: accessibleRoomSelections[roomIndex] === _api.ROOM_TYPE.BARRIER_FREE,
        isDisabled: !hasBarrierFreeRoom,
        children: (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [(0, _jsxRuntime.jsx)(_react.Text, {
            fontWeight: "bold",
            "data-testid": "accessible-barrier-free-room",
            children: t('accessible.barrierFree')
          }), (0, _jsxRuntime.jsx)(_react.Box, {
            className: "formatLinks",
            children: (0, _utils.renderSanitizedHtml)(t('accessible.barrierFree.text'))
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_react.Box, {
        mt: "md",
        children: [(0, _jsxRuntime.jsx)(_atoms.Notification, {
          title: t('accessible.standardRoom'),
          description: t('accessible.standardRoom.alertText'),
          prefixDataTestId: "accessible-standardRoom",
          status: "warning",
          variant: "alert",
          svg: (0, _jsxRuntime.jsx)(_atoms.Alert, {}),
          isClosed: hasAccessibleRoom,
          style: {
            maxWidth: 'none'
          },
          isInnerHTML: true
        }), (0, _jsxRuntime.jsx)(_atoms.Notification, {
          title: t('accessible.barrierFree'),
          description: t('accessible.barrierFree.alertText'),
          prefixDataTestId: "accessible-barrierFree",
          status: "warning",
          variant: "alert",
          svg: (0, _jsxRuntime.jsx)(_atoms.Alert, {}),
          isClosed: hasBarrierFreeRoom,
          style: {
            maxWidth: 'none'
          },
          isInnerHTML: true
        })]
      })]
    });
  }
}
var headingStyle = {
  fontWeight: 'semibold',
  fontSize: {
    base: '3xl',
    sm: '3xxl'
  },
  lineHeight: {
    base: '4',
    sm: '5'
  }
};
var roomAndGuestsFlexStyle = {
  mb: 'sm',
  flexDirection: {
    base: 'column',
    xs: 'row'
  },
  w: {
    base: '100%',
    sm: '64%',
    md: '50%'
  }
};
var roomHeadingStyle = {
  fontWeight: 'semibold',
  fontSize: '2xl',
  lineHeight: '4'
};